import React, { useCallback } from "react";
import { useSdkContext } from "scmp-sdk/components/contexts";
import { useGA4CommonParameters, useSendImpressionEvents } from "scmp-sdk/components/rosetta/hooks";
import { SubscriptionButton } from "scmp-sdk/components/rosetta/subscription-button/styles";
import type { GA4Event } from "scmp-sdk/lib/google-analytics/ga4-types";

import { PageType } from "shared/lib/page-type";

type Props = {
  className?: string;
  location: "footer" | "masthead" | "print-button";
};
export const ReactivateButton: React.FunctionComponent<Props> = ({ className, location }) => {
  const { config, currentPageType, handleTrackGA4 } = useSdkContext();
  const { computeGA4CommonParameters } = useGA4CommonParameters();

  const { captureTrackImpressionEventTargetElement } = useSendImpressionEvents({
    ga4Event: useCallback<() => GA4Event>(
      () => ({
        action: "imp",
        category: "subs",
        customized_parameters: {
          ...computeGA4CommonParameters(),
          call_to_action: "reactivation",
          trigger_point: "masthead reactivation button",
        },
        subcategory: "entry_point",
      }),
      [computeGA4CommonParameters],
    ),
  });
  return (
    <SubscriptionButton
      className={className}
      onClick={() => {
        const trigger_point = (() => {
          if (location === "masthead") {
            return "masthead reactivation button";
          }
          switch (currentPageType) {
            case PageType.Article:
              return "article footer";

            case PageType.Homepage:
              return "homepage footer";

            case PageType.Section:
              return "section footer";

            default:
              return "footer";
          }
        })();

        handleTrackGA4({
          action: "click",
          category: "subs",
          customized_parameters: {
            ...computeGA4CommonParameters(),
            call_to_action: "reactivation",
            trigger_point,
          },
          subcategory: "entry_point",
        });
        globalThis.location.href = `${config.subscribe.host}/?product=winback`;
      }}
      ref={captureTrackImpressionEventTargetElement}
    >
      Reactivate Access
    </SubscriptionButton>
  );
};

ReactivateButton.displayName = "ReactivateButton";
